import type { SearchResult, SessionData } from '@optionway/models';
import { modelsImpl } from '@optionway/models';

interface SelectedSearchResultStore {
  result?: SearchResult;
}

// The GDS may answer the pricing under another offer id.
export const useSelectedSearchResultStore = defineStore('selected-search-result', {
  state: (): SelectedSearchResultStore => ({
    result: undefined,
  }),
  getters: {
    toBody: () => {
      const { SelectedFlightImpl } = modelsImpl;
      return (sessionData: SessionData, offerUuid: SearchResult['offerUuid']) => {
        const selectedFlightObject = new SelectedFlightImpl();
        selectedFlightObject.flight.offerUuid = offerUuid;
        selectedFlightObject.sessionData = sessionData;
        console.log('selectedFlightObject:', JSON.stringify(selectedFlightObject));
        return toPojo(selectedFlightObject);
      };
    },
  },
  actions: {
    select(result: SearchResult) {
      this.result = result;
    },
  },
});
